const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const API_URL = `${SERVER_URL}/course/course_search`;

const PHONE_REGEX = /^[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$/;
// const PHONE_REGEX = /^(3[0-9]{2})([0-9]{7})$/;

export { API_URL, SERVER_URL, PHONE_REGEX };
